import { render, staticRenderFns } from "./EficiencyComponent.vue?vue&type=template&id=32bef3cc&scoped=true&"
import script from "./EficiencyComponent.vue?vue&type=script&lang=ts&"
export * from "./EficiencyComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EficiencyComponent.vue?vue&type=style&index=0&id=32bef3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bef3cc",
  null
  
)

export default component.exports